import { ChangeEventHandler, FC, useState } from "react";
import { UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { GenerateBookPDFData } from "../Modals/GenerateBookPDFModals/GenerateBookPDFModalStep3";

type Props = {
  id: keyof GenerateBookPDFData;
  label: string;
  setValue: UseFormSetValue<GenerateBookPDFData>;
  dateValue: string;
  setDateValue: (value: string) => void;
};

const DateInput: FC<Props> = ({
  id,
  label,
  setValue,
  dateValue,
  setDateValue,
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState("");

  type HandleDateChangeEvent = React.ChangeEvent<HTMLInputElement>;

  const handleDateChange: ChangeEventHandler<HTMLInputElement> = (
    e: HandleDateChangeEvent
  ) => {
    const value = e.target.value;

    // Autorise seulement les chiffres et les /
    if (!/^[\d/]*$/.test(value)) {
      setError(t("errors.invalidCharacters"));
      return;
    }

    // Formatage automatique
    let formattedValue = value;

    // Ajoute automatiquement les /
    if (value.length === 2 && dateValue.length === 1) {
      formattedValue = value + "/";
    } else if (value.length === 5 && dateValue.length === 4) {
      formattedValue = value + "/";
    }

    setDateValue(formattedValue);
    setValue(id, formattedValue);

    // Validation du format JJ/MM/AAAA
    if (formattedValue.length === 10) {
      const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      const matches = formattedValue.match(datePattern);

      if (!matches) {
        setError(t("errors.invalidDateFormat"));
        return;
      }

      const day = parseInt(matches[1], 10);
      const month = parseInt(matches[2], 10);
      const year = parseInt(matches[3], 10);

      if (month < 1 || month > 12) {
        setError(t("errors.invalidMonth"));
        return;
      }

      // Validation des jours selon le mois
      const daysInMonth = new Date(year, month, 0).getDate();
      if (day < 1 || day > daysInMonth) {
        setError(t("errors.invalidDay"));
        return;
      }

      setError("");
    } else {
      setError("");
    }
  };

  return (
    <div className="w-full">
      <label
        htmlFor={`date-input-${id}`}
        className="block text-sm font-medium text-slate-700 mb-1 text-left"
      >
        {label}
      </label>
      <input
        id={`date-input-${id}`}
        type="text"
        value={dateValue}
        onChange={handleDateChange}
        placeholder="JJ/MM/AAAA"
        maxLength={10}
        className="w-full px-3 py-2 border border-gray-300 rounded shadow-sm 
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-left"
      />
      {error && <p className="mt-1 text-sm text-red-600 text-left">{error}</p>}
    </div>
  );
};

export default DateInput;
